import { cn } from "../../lib/cn";

interface PulseIndicatorProps {
  status: "ok" | "warn" | "error" | "off" | "loading";
  size?: "sm" | "md";
  className?: string;
  /** Подпись справа от индикатора. */
  label?: string;
}

const STATUS_COLORS = {
  ok: "bg-success",
  warn: "bg-warning",
  error: "bg-danger",
  off: "bg-fg-subtle",
  loading: "bg-accent-400",
} as const;

/**
 * Цветной кружок-статус с пульсирующим кольцом — connection / running / paused / error.
 * Используется в EnvironmentBanner, VPS, MetricsDashboard, sidebar-footer.
 */
export function PulseIndicator({
  status,
  size = "sm",
  className,
  label,
}: PulseIndicatorProps) {
  const dotSize = size === "sm" ? "size-2" : "size-2.5";
  const color = STATUS_COLORS[status];
  const showRing = status === "ok" || status === "loading";

  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <span className={cn("relative inline-flex", dotSize)}>
        {showRing && (
          <span
            className={cn(
              "absolute inset-0 rounded-full opacity-60",
              color,
              "animate-pulse-ring",
            )}
          />
        )}
        <span className={cn("relative inline-block w-full h-full rounded-full", color)} />
      </span>
      {label && <span className="text-small text-fg-muted">{label}</span>}
    </span>
  );
}
